export class TRCQGroup {
    questionGroupId = 0
    questionGroup  = ""
    seqNbr = 0
    notes = ""
    metaName = ""
}